import React from 'react';

import Chip from '@material-ui/core/Chip';
import LinearProgress from "@material-ui/core/LinearProgress";
import Popper from '@material-ui/core/Popper';
import TextField from '@material-ui/core/TextField';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';


import InfiniteScroll from 'react-infinite-scroll-component';
import mtzApis from '../../../../services';
const { companyService } = mtzApis;

function CategorySelect({ onChange, categoryIds, title, subtitle, categoryResourceLimit }) {
	let [useNAICS, setUseNAICS] = React.useState(false);

	return (
		<div className="p-1 d-flex flex-column mtz-gap-16">
			<h5 className="mtz-h5 text-center">{!title ? 'Select Categories' : title}</h5>

			{useNAICS && <NAICSSelect categoryResourceLimit={categoryResourceLimit}
				onChange={onChange} categoryIds={categoryIds} />}

			{
				!useNAICS &&
				<SimpleSelect title={title} categoryIds={categoryIds} categoryResourceLimit={categoryResourceLimit} subtitle={subtitle} onChange={onChange} />
			}

			<div className='text-right'>
				<div className='form-check'>
					<input type='checkbox' className='form-check-input' onChange={e => setUseNAICS(e.target.checked)} />
					<label className='form-check-label text-muted'><small>Use NAICS categories</small></label>
				</div>
			</div>
		</div>
	);
};

function SimpleSelect({ onChange, categoryResourceLimit, categoryIds }) {
	let [simCats, setSimCats] = React.useState([]);
	let [selecteds, setSelecteds] = React.useState([]);

	React.useEffect(() => {
		init();
	}, [categoryIds]);

	const init = async () => {
		simCats = await companyService.getCategories(new URLSearchParams(`type=SIMPLE&limit=1000`));
		setSimCats(simCats);

		selecteds = await companyService.getCategories(new URLSearchParams(`categoryIds=${categoryIds}&limit=1000`));
		if (selecteds)
			setSelecteds(selecteds);
	};

	const search = async e => {
		simCats = await companyService.getCategories(new URLSearchParams(`limit=1000&type=SIMPLE${e.target.value && `&keyword=${e.target.value}`}`));
		setSimCats(simCats);
	};

	const addSelected = category => {
		if (categoryResourceLimit && selecteds.length < categoryResourceLimit) {
			selecteds = [...selecteds, category];
			setSelecteds(selecteds)
			if (onChange)
				onChange(selecteds.map(s => s.id));
		} else
			alert(`You have reached max ${categoryResourceLimit} categories selected`);
	};

	const delSelected = category => {
		selecteds = selecteds.filter(s => s.id !== category.id);
		setSelecteds(selecteds);
		if (onChange)
			onChange(selecteds.map(s => s.id));
	};

	return (
		<>
			<div className="m-2">
				<div>
					<b><u>Select up to {categoryResourceLimit} categories.</u></b> You have {categoryResourceLimit - selecteds.length} left.
				</div>

				{
					selecteds.map(selected => (
						<Chip color="primary" onDelete={() => delSelected(selected)} className="m-1" key={selected.id} label={selected.name} />
					))
				}
			</div>

			<div className='dropdown'>
				<input placeholder='Enter keyword to search' onChange={search}
					className='form-control dropdown-toggle' data-toggle='dropdown' />

				<div className='dropdown-menu' style={{ maxHeight: '300px', overflowY: "scroll" }}>
					{
						simCats.map(cat => (
							<form key={cat.id}>
								<div key={cat.id} className='dropdown-item'>
									<label className='form-check-label d-block p-1' >
										<input
											type='checkbox'
											checked={!!selecteds.find(s => s.id === cat.id)}
											onChange={e => e.target.checked ? addSelected(cat) : delSelected(cat)}
											className='form-check-input'
										/>
										{cat.name}
									</label>
								</div>
							</form>
						))
					}

				</div>
			</div >
		</>
	);
};

function NAICSSelect({ onChange, categoryIds, categoryResourceLimit }) {
	let [categories, setCategories] = React.useState(null);
	let [loading, setLoading] = React.useState(false);
	let [selecteds, setSelecteds] = React.useState([]);
	let [searches, setSearches] = React.useState(null);
	let [helpAnchor, setHelpAnchor] = React.useState(null);
	let [limit, setLimit] = React.useState(16);
	let [keyword, setKeyword] = React.useState();
	let [hasMore, setHasMore] = React.useState(true);

	const searchResultsContainerRef = React.useRef(null);
	React.useEffect(() => {
		const handleClickOutsideSearchResults = (event) => {
			if (
				searchResultsContainerRef.current &&
				!searchResultsContainerRef.current.contains(event.target)
			) {
				// Hide the search results when clicking outside
				setSearches(null);
			}
		};

		document.addEventListener('mousedown', handleClickOutsideSearchResults);

		return () => {
			document.removeEventListener('mousedown', handleClickOutsideSearchResults);
		};
	}, []);


	React.useEffect(() => {
		init();
	}, [categoryIds]);

	const init = async () => {
		setLoading(true);
		let founds = await companyService.getCategories(new URLSearchParams(`type=NAICS&parentId=root&limit=10000&skip=0`));
		setLoading(false);

		if (founds) {
			// Move the first element to the end of the array
			const firstCategory = founds.shift();
			founds.push(firstCategory);
			setCategories(founds);
		}

		selecteds = await companyService.getCategories(new URLSearchParams(`limit=1000&categoryIds=${categoryIds}`));
		if (selecteds)
			setSelecteds(selecteds);
	};

	const addSelected = category => {
		if (categoryResourceLimit && selecteds.length < categoryResourceLimit) {
			selecteds = [...selecteds, category];
			setSelecteds(selecteds)
			if (onChange)
				onChange(selecteds.map(s => s.id));
		}
		else
			alert(`You have reached max ${categoryResourceLimit} categories selected`);
	};

	const delSelected = category => {
		selecteds = selecteds.filter(s => s.id !== category.id);
		setSelecteds(selecteds);
		if (onChange)
			onChange(selecteds.map(s => s.id));
	};

	const onSearch = async e => {
		if (!(e.target.value) || (e.target.value).trim() === '') {

			setSearches([]);
			return;
		}
		setKeyword(e.target.value)

		let founds = await companyService.getCategories(new URLSearchParams(`type=NAICS&keyword=${e.target.value}&limit=${limit}`));


		if (founds)
			setSearches(founds);
	};
	const debouncedOnSearch = debounce((value) => onSearch({ target: { value } }), 100); // Adjust the debounce delay as needed
	function debounce(func, delay) {
		let timeoutId;
		return function (...args) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	const loadSearches = async (limit) => {

		let newSearches = await companyService.getCategories(new URLSearchParams(`type=NAICS&keyword=${keyword}&limit=${limit}`));
		return newSearches;

	}

	const onScroll = async () => {
		let updatedLimit = limit + 16;
		let newSearches = await loadSearches(updatedLimit);

		setLimit(updatedLimit);
		if (newSearches.length > searches.length) {
			setHasMore(true);
			setSearches(newSearches);
		}
		else {
			setHasMore(false);
			setSearches(newSearches);
		}
	};

	return (
		<>
			<div className="p-1 d-flex flex-column">
				<div className="text-right">
					<span onClick={e => helpAnchor ? setHelpAnchor(null) : setHelpAnchor(e.target)} className='btn alert-success badge badge-pill px-4 py-2'>What's the <u>NAICS</u> code?</span>
					<Popper open={!!helpAnchor} anchorEl={helpAnchor} style={{ zIndex: 9999 }}>
						<div className="shadow p-2 bg-white" style={{ maxWidth: '500px' }}>
							The North American Industry Classification System (NAICS) is the standard used by Federal statistical agencies in classifying business establishments for the purpose of collecting, analyzing, and publishing statistical data related to the U.S. business economy.
							<div><a target="_blank" href="https://www.census.gov/naics">{"Learn more >>>"}</a></div>
							<div className="text-right">
								<button onClick={() => setHelpAnchor(null)} className="btn btn-sm btn-secondary">Close</button>
							</div>
						</div>
					</Popper>
				</div>

				<div className="m-2">
					<div>
						<b><u>Select up to {categoryResourceLimit} categories.</u></b> You have {categoryResourceLimit - selecteds.length} left.
					</div>

					{
						selecteds.map(selected => (
							<Chip color="primary" onDelete={() => delSelected(selected)} className="m-1" key={selected.id} label={selected.name} />
						))
					}
				</div>

				<div className="m-1" >
					<TextField
						type="text"
						onChange={(e) => debouncedOnSearch(e.target.value)}
						variant="outlined"
						label="Type here to search your industry"
						placeholder="Enter industry keyword"
						margin='dense'
						size="medium"
						fullWidth

					/>
				</div>
				<div className={'overflow-auto'} id="scrollableDiv2" style={{ maxHeight: 300 }} ref={searchResultsContainerRef}>
					{searches && searches.length > 0 ? (
						<InfiniteScroll
							dataLength={searches.length}
							next={() => onScroll()}
							hasMore={hasMore}
							loader={<LinearProgress />}
							endMessage={
								<p style={{ textAlign: 'center' }}>
									<b>End</b>
								</p>
							}
							scrollableTarget="scrollableDiv2"

						>
							{searches.map((c, index) => (
								<button key={c.id} style={{ cursor: 'pointer', border: 'none', background: 'none', padding: '0', textAlign: 'left' }} className="d-flex flex-wrap my-1 border rounded" onClick={() => {
									if (selecteds.find(s => s.id === c.id)) {
										// If the category is already selected, deselect it
										delSelected(c);
									} else {
										// If the category is not selected, select it
										addSelected(c);
									}
								}}>
									{
										c.parents &&
										c.parents.reverse().map((p, i) => (
											<span key={p.id} className="d-flex align-items-center text-secondary">
												{i === 0 && <span className="mx-2 text-primary"> / </span>}
												<span className="d-flex align-items-center rounded p-1 m-1">
													<span><small>{p.name}</small> - <small className="badge badge-pill border">NAICS: {p.naiscCode || 'N/A'}</small></span>
												</span>
												<span className="mx-2 text-primary"> / </span>
											</span>
										))
									}
									<b key={c.id} className="d-flex align-items-center rounded p-1 m-1">
										<input type="checkbox" checked={!!selecteds.find(s => s.id === c.id)} />
										&nbsp;-&nbsp;
										<b><span>{c.name}</span> - <span className="text-primary badge badge-pill border border-primary">NAICS: {c.naiscCode || 'N/A'}</span></b>
									</b>
								</button>
							))}


						</InfiniteScroll>
					) : (
						searches && keyword && keyword.length != 0 &&
						<p>No records found</p>

					)


					}
				</div>

				<div className="my-2">
					<h5 className="h5 text-border ml-3"><u><b>*OR select available categories below:</b></u></h5>
					<div className="flex-grow-1 overflow-auto my-2" style={{ maxHeight: '500px' }}>
						{categories === null && "Loading..."}

						{categories && categories.length === 0 && 'No category found'}

						{
							categories && categories.length > 0 &&
							categories.filter(c => !!c).map((c, i) => (
								<div key={c.id}>
									<CategoryOption selecteds={selecteds} delSelected={delSelected} addSelected={addSelected} category={c} index={i} />
								</div>
							))
						}
					</div>
				</div>
			</div >
		</>
	);
};

function CategoryOption({ category, index, addSelected, delSelected, selecteds }) {
	let [expand, setExpand] = React.useState(false);
	let [categories, setCategories] = React.useState(null);
	const ref = React.useRef();

	React.useEffect(() => {
	}, []);

	const loadChildren = async () => {
		let founds = await companyService.getCategories(new URLSearchParams(`type=NAICS&parentId=${category.id}`));
		if (founds)
			setCategories(founds);
		setExpand(!expand);
	};

	return (
		<div ref={ref} className={"ml-3 py-2 hover-light rounded" + (index !== 0 ? " border-top" : '')}>
			<div>
				<div className="d-flex align-items-center text-left">
					<span className="mx-2">
						<input checked={!!selecteds.find(s => s.id === category.id)} type="checkbox"
							onChange={() => !!selecteds.find(s => s.id === category.id) ? delSelected(category) : addSelected(category)} />
					</span>

					<div className="mtz-cursor-pointer flex-grow-1" onClick={loadChildren}>
						<span className="mr-1">
							{!expand ? <ArrowRightIcon /> : <ArrowLeftIcon className="text-primary" />}
						</span>
						{category.name}
					</div>

					<small className="mx-2 p-2 text-primary badge badge-pill alert-light border">NAICS: {category.naiscCode || 'N/A'}</small>
				</div>
			</div>

			{
				expand &&
				<div className="flex-grow-1 overflow-auto">
					{categories === null && "Loading..."}

					{categories && categories.length === 0 && <small className="ml-3 text-danger">*You have reached the last level</small>}

					{
						categories && categories.length > 0 &&
						categories.map((c, i) => (
							<div key={c.id}>
								<CategoryOption selecteds={selecteds} delSelected={delSelected} addSelected={addSelected} category={c} index={i} />
							</div>
						))
					}
				</div>
			}
		</div>
	);
}

CategorySelect.defaultProps = {
	categoryResourceLimit: 5
}

export default CategorySelect;